import { render, staticRenderFns } from "./bitacora_empresa.vue?vue&type=template&id=30507256&scoped=true"
import script from "./bitacora_empresa.vue?vue&type=script&lang=js"
export * from "./bitacora_empresa.vue?vue&type=script&lang=js"
import style0 from "./bitacora_empresa.vue?vue&type=style&index=0&id=30507256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30507256",
  null
  
)

export default component.exports